const hamburger = document.getElementById('hamburger');
const menu = document.getElementById('mobileMenu');
const dropdown = document.querySelector('.nav-dropdown');
const toggle = document.querySelector('.dropdown-toggle');

  hamburger.addEventListener('click', () => {
    menu.classList.toggle('active');
    hamburger.classList.toggle('active');

    if (!menu.classList.contains('active') && mobileBreakpoint.matches) {
      document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');

        dropdown.classList.remove('open');
        dropdownMenu.style.height = '0px';
      });
    }
  });

  document.addEventListener('click', (e) => {
  if (!mobileBreakpoint.matches) return;

  const clickedInsideMenu =
    menu.contains(e.target) ||
    hamburger.contains(e.target);

  if (!clickedInsideMenu && menu.classList.contains('active')) {
    menu.classList.remove('active');
    hamburger.classList.remove('active');

    document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
      const dropdownMenu = dropdown.querySelector('.dropdown-menu');

      dropdown.classList.remove('open');
      dropdownMenu.style.height = '0px';
    });
  }
});

  const mobileBreakpoint = window.matchMedia('(max-width: 1200px)');

  function resetDropdownsForDesktop() {
    if (!mobileBreakpoint.matches) {
      document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
        const menu = dropdown.querySelector('.dropdown-menu');

        dropdown.classList.remove('open');
        menu.style.removeProperty('height');
      });
    }
  }

  document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const menu = dropdown.querySelector('.dropdown-menu');

    toggle.addEventListener('click', (e) => {
      if (!mobileBreakpoint.matches) return;

      e.preventDefault();

      const isOpening = !dropdown.classList.contains('open');

      if (isOpening) {
        dropdown.classList.add('open');

        menu.style.height = '0px';

        requestAnimationFrame(() => {
          menu.style.height = `${menu.scrollHeight}px`;
        });
      } else {
        menu.style.height = `${menu.scrollHeight}px`;

        requestAnimationFrame(() => {
          dropdown.classList.remove('open');
          menu.style.height = '0px';
        });
      }
    });

    menu.addEventListener('transitionend', (e) => {
      if (e.propertyName !== 'height') return;

      if (dropdown.classList.contains('open')) {
        menu.style.height = 'auto';
      }
    });
  });

  mobileBreakpoint.addEventListener('change', resetDropdownsForDesktop);
  window.addEventListener('resize', resetDropdownsForDesktop);

  resetDropdownsForDesktop();

  let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;

  if (Math.abs(currentScrollY - lastScrollY) > 5) {
    menu.classList.remove('active');
    hamburger.classList.remove('active');

    if (mobileBreakpoint.matches) {
      document.querySelectorAll('.nav-dropdown').forEach((dropdown) => {
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');

        dropdown.classList.remove('open');
        dropdownMenu.style.height = '0px';
      });
    }
  }

  lastScrollY = currentScrollY;
});